import React, { Component } from 'react';

import CodeEntry from './code_entry/code_entry';
import Registration from './registration/registration';
import EmailConfirmation from './email_confirmation/email_confirmation';
import Error from './error/error';

export default class Content extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // step: 'promo_over',
      step: 'code_entry',
      // step: 'email_confirmation',
      // step: 'registration',
      ref_value: null,
      // code_type: 'account_created',
      // code_type: 'contract_added',
      code_value: null,
    };

    this.updateStep = this.updateStep.bind(this);
  }

  updateStep(step, ref_value, code_type, code_value) {
    this.setState({ step, ref_value, code_type, code_value });
  }

  render() {
    if (this.state.step === 'code_entry') {
      return <CodeEntry updateStep={ this.updateStep } />;
    } else if (this.state.step === 'registration' && this.state.ref_value) {
      return <Registration updateStep={ this.updateStep } ref_value={ this.state.ref_value } code_type={ this.state.code_type} code_value={ this.state.code_value}  />;
    } else if (this.state.step === 'email_confirmation' && this.state.ref_value) {
      return <EmailConfirmation ref_value={ this.state.ref_value } success_type={ this.state.code_type } />;
    }

    return <Error error={ this.state.step } message={ this.state.ref_value } />;
  }
}



// WEBPACK FOOTER //
// ./src/content/content.js